import React from "react";
import { SovosButton } from "mosaic-react";
import { AddCircleOutline } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const TranslationTableFormButton = () => {
    const { pushModal, i18n, reload } = useGlobalValue();
    return (
        <>
            <SovosButton
                disabled={false}
                key="translationForm"
                children={i18n`Create new`}
                startIcon={<AddCircleOutline />}
                onClick={() => {
                    pushModal({
                        title: i18n`Create new Translation Table`,
                        view: `TranslationTableForm`,
                        data: { __typename: "TranslationTable" },
                    })
                        .then(() => {
                            reload && reload();
                        })
                        .catch(() => null);
                }}
            />
        </>
    );
};

export default TranslationTableFormButton;
